export default {
  helpMQTT: {
    zh: '关于 MQTT 的一切',
    en: 'Everything about MQTT',
    ja: 'MQTT について',
    tr: 'MQTT hakk',
    hu: 'Minden MQTT-ről',
  },
  docs: {
    zh: 'MQTTX 文档',
    en: 'MQTTX Documentation',
    ja: 'MQTTX ドキュメント',
  },
  forum: {
    zh: 'MQTTX 论坛',
    en: 'MQTTX Forum',
    ja: 'MQTTX フォーラム',
  },
  learn: {
    zh: '学习 MQTT',
    en: 'Learn MQTT',
    ja: 'MQTT を学ぶ',
  },
  publicMqttBroker: {
    zh: 'MQTT 公共服务器',
    en: 'Public MQTT Broker',
    ja: '公共 MQTT ブローカー',
    tr: 'Herkese açık MQTT Broker',
    hu: 'Nyilvános MQTT Broker',
  },
  mqtt5Explore: {
    zh: 'MQTT 5 探索',
    en: 'MQTT 5 Explore',
    ja: 'MQTT 5 を探る',
    tr: 'MQTT 5 Keşfedin',
    hu: 'Fedezze fel az MQTT 5-öt',
  },
  guideTitle: {
    zh: 'MQTT 入门',
    en: 'MQTT Beginner’s Guide',
    ja: 'MQTT 初心者ガイド',
  },
  guideDesc: {
    zh: '丰富、易理解的 MQTT 指南，助您快速入门 MQTT 协议。',
    en: 'The rich and easy-to-understand MQTT guide to help you quickly get started with MQTT protocol.',
    ja: '豊富で分かりやすい MQTT ガイドで、MQTT プロトコルをすぐに始めることができます。',
  },
  guideArticle1: {
    zh: '物联网首选协议，关于 MQTT 你需要了解这些',
    en: 'What is The MQTT and Why is it the Best Protocol for IoT?',
    ja: 'What is The MQTT and Why is it the Best Protocol for IoT?',
  },
  guideArticle2: {
    zh: 'MQTT 协议快速体验',
    en: 'The Easiest Guide to Getting Started with MQTT',
    ja: 'The Easiest Guide to Getting Started with MQTT',
  },
  guideArticle3: {
    zh: 'MQTT 发布订阅模式介绍',
    en: 'Introduction to MQTT publish-subscribe model',
    ja: 'Introduction to MQTT publish-subscribe model',
  },
  guideArticle4: {
    zh: '创建 MQTT 连接时如何设置参数？',
    en: 'How to Set Parameters When Establishing an MQTT Connection?',
    ja: 'How to Set Parameters When Establishing an MQTT Connection?',
  },
  guideArticle5: {
    zh: '通过案例理解 MQTT 主题与通配符',
    en: 'Understanding MQTT Topics & Wildcards by Case',
    ja: 'Understanding MQTT Topics & Wildcards by Case',
  },
  guideArticle6: {
    zh: 'MQTT 持久会话与 Clean Session 详解',
    en: 'MQTT Persistent Session and Clean Session Explained',
    ja: 'MQTT Persistent Session and Clean Session Explained',
  },
  guideArticle7: {
    zh: 'MQTT QoS 0, 1, 2 介绍',
    en: 'Introduction to MQTT QoS 0, 1, 2',
    ja: 'Introduction to MQTT QoS 0, 1, 2',
  },
  guideArticle8: {
    zh: 'MQTT 保留消息是什么？如何使用？',
    en: "The Beginner's Guide to MQTT Retained Messages",
    ja: "The Beginner's Guide to MQTT Retained Messages",
  },
  guideArticle9: {
    zh: 'MQTT 遗嘱消息（Will Message）的使用',
    en: 'Use of MQTT Will Message',
    ja: 'Use of MQTT Will Message',
  },
  guideArticle10: {
    zh: 'MQTT 协议 Keep Alive 详解',
    en: 'What is the MQTT Keep Alive parameter for?',
    ja: 'What is the MQTT Keep Alive parameter for?',
  },
  practiceTitle: {
    zh: 'MQTT 编程',
    en: 'MQTT Programming',
    ja: 'MQTT プログラミング',
  },
  practiceDesc: {
    zh: '丰富的的 MQTT 实战代码，助您快速开发 MQTT 服务及应用。',
    en: 'Rich MQTT practice code to help you quickly develop MQTT services and applications.',
    ja: '豊富な MQTT 実践コードで、MQTT サービスとアプリケーションをすぐに開発できます。',
  },
  miniProgram: {
    zh: '微信小程序',
    en: 'WeChat Mini Program',
    ja: 'WeChat Mini Program',
  },
  raspberryPi: {
    zh: '树莓派',
    en: 'Raspberry Pi',
    ja: 'Raspberry Pi',
  },
}
